import { ReactNode } from "react";

type FilterGroupProps = {
  label: ReactNode;
  control: ReactNode;
};
export default function FilterGroup({ label, control }: FilterGroupProps) {
  return (
    <div>
      <h4 className="font-bold">{label}</h4>
      {control}
    </div>
  );
}
